import { pprops } from '@frontend/sports/common/core/utils/redux';
import { createAction, props } from '@ngrx/store';

import BetslipActions from '../../base/store/actions';
import { CashierPage, DepositAvailable, FundsAdded, SelectedPaymentMethod, WindowResize, WindowScroll } from './quick-deposit.models';

export class QuickDepositActions {
    static readonly ACTION_SCHEMA = `${BetslipActions.ACTION_SCHEMA}/quick_deposit`;

    private static readonly DEPOSIT_AVAILABLE = `${QuickDepositActions.ACTION_SCHEMA}/DEPOSIT_AVAILABLE`;
    private static readonly SELECTED_PAYMENT_METHOD = `${QuickDepositActions.ACTION_SCHEMA}/SELECTED_PAYMENT_METHOD`;
    private static readonly FUNDS_ADDED = `${QuickDepositActions.ACTION_SCHEMA}/FUNDS_ADDED`;
    private static readonly WINDOW_RESIZE = `${QuickDepositActions.ACTION_SCHEMA}/WINDOW_RESIZE`;
    private static readonly WINDOW_SCROLL = `${QuickDepositActions.ACTION_SCHEMA}/WINDOW_SCROLL`;
    private static readonly DEPOSIT_PROCESSING = `${QuickDepositActions.ACTION_SCHEMA}/DEPOSIT_PROCESSING`;
    private static readonly CASHIERPAGE = `${QuickDepositActions.ACTION_SCHEMA}/CASHIERPAGE`;
    private static readonly OPEN = `${QuickDepositActions.ACTION_SCHEMA}/OPEN`;
    private static readonly CLOSE = `${QuickDepositActions.ACTION_SCHEMA}/CLOSE`;
    private static readonly VISIBLE = `${QuickDepositActions.ACTION_SCHEMA}/VISIBLE`;

    static depositAvailable = createAction(QuickDepositActions.DEPOSIT_AVAILABLE, pprops<DepositAvailable>());
    static selectedPaymentMethod = createAction(QuickDepositActions.SELECTED_PAYMENT_METHOD, pprops<SelectedPaymentMethod>());
    static fundsAdded = createAction(QuickDepositActions.FUNDS_ADDED, pprops<FundsAdded>());
    static windowResize = createAction(QuickDepositActions.WINDOW_RESIZE, pprops<WindowResize>());
    static windowScroll = createAction(QuickDepositActions.WINDOW_SCROLL, pprops<WindowScroll>());
    static depositProcessing = createAction(QuickDepositActions.DEPOSIT_PROCESSING, props<{ processing: boolean }>());
    static cashierPage = createAction(QuickDepositActions.CASHIERPAGE, pprops<CashierPage>());
    static quickDepositOpen = createAction(QuickDepositActions.OPEN);
    static quickDepositClose = createAction(QuickDepositActions.CLOSE, props<{ close: boolean }>());
    static quickDepositVisible = createAction(QuickDepositActions.VISIBLE, props<{ visible: boolean }>());
}
